module.exports = __webpack_public_path__ + "img/01prge.144eb805.png";